import type { PixelSprite } from '../types.js';
const variant0: PixelSprite = {
  layers: [
    { paint: 'shadow', d: 'M-1.5,0h1v0.5h-1zM1,0h1v0.5h-1z' },
    {
      paint: 'trunk',
      d: 'M-1,-4.5h2.5v1h-2.5zM-1,-3.5h0.5v0.5h-0.5zM0,-3.5h1.5v0.5h-1.5zM-0.5,-3h1.5v0.5h-1.5zM-0.5,-2.5h0.5v1.5h-0.5zM0.5,-2.5h0.5v2h-0.5zM-1,-1h0.5v1h-0.5zM0,-0.5h1v0.5h-1zM-0.5,0h1.5v0.5h-1.5z',
    },
    {
      paint: 'stump',
      d: 'M-0.5,-3.5h0.5v0.5h-0.5zM0,-2.5h0.5v1.5h-0.5zM-0.5,-1h1v0.5h-1zM-0.5,-0.5h0.5v0.5h-0.5z',
    },
    {
      paint: 'willow',
      d: 'M0.5,-8.5h1v0.5h-1zM-2.5,-8h0.5v1.5h-0.5zM1,-8h1v0.5h-1zM1,-7.5h1.5v0.5h-1.5zM-0.5,-7h3v0.5h-3zM-3,-6.5h1v0.5h-1zM-1,-6.5h4v0.5h-4zM-3.5,-6h1v0.5h-1zM-1.5,-6h4.5v1h-4.5zM-3.5,-5.5h0.5v0.5h-0.5zM-4,-5h0.5v2h-0.5zM-2,-5h5v0.5h-5zM-2,-4.5h1v1h-1zM1.5,-4.5h1.5v2h-1.5zM-3,-4h0.5v0.5h-0.5zM-3,-3.5h2v0.5h-2zM-4,-3h3v0.5h-3zM-4,-2.5h2.5v0.5h-2.5zM2,-2.5h1v1h-1zM-4,-2h2v0.5h-2zM-4,-1.5h1.5v0.5h-1.5zM-3,-1h0.5v0.5h-0.5z',
    },
    { paint: 'bushDark', d: 'M2.5,-7.5h0.5v0.5h-0.5zM2.5,-7h1v0.5h-1zM3,-6.5h1v5.5h-1z' },
    {
      paint: 'leafLight',
      d: 'M-1.5,-8.5h2v0.5h-2zM-2,-8h3v1h-3zM-2,-7h1.5v0.5h-1.5zM-2,-6.5h1v0.5h-1zM-2.5,-6h1v0.5h-1zM-3,-5.5h1.5v0.5h-1.5zM-3.5,-5h1.5v1h-1.5zM-3.5,-4h0.5v1h-0.5zM-2.5,-4h0.5v0.5h-0.5z',
    },
  ],
  pixels: 207,
};
const variant1: PixelSprite = {
  layers: [
    { paint: 'shadow', d: 'M-1.5,0h1v0.5h-1zM1,0h1v0.5h-1z' },
    {
      paint: 'trunk',
      d: 'M-1,-4h2.5v0.5h-2.5zM-1,-3.5h0.5v0.5h-0.5zM0,-3.5h1.5v0.5h-1.5zM-0.5,-3h1.5v0.5h-1.5zM-0.5,-2.5h0.5v1.5h-0.5zM0.5,-2.5h0.5v2h-0.5zM-1,-1h0.5v1h-0.5zM0,-0.5h1v0.5h-1zM-0.5,0h1.5v0.5h-1.5z',
    },
    {
      paint: 'stump',
      d: 'M-0.5,-3.5h0.5v0.5h-0.5zM0,-2.5h0.5v1.5h-0.5zM-0.5,-1h1v0.5h-1zM-0.5,-0.5h0.5v0.5h-0.5z',
    },
    {
      paint: 'willow',
      d: 'M-2.5,-7h1.5v0.5h-1.5zM-0.5,-7h1.5v0.5h-1.5zM-3,-6.5h0.5v1.5h-0.5zM1,-6.5h1v0.5h-1zM1,-6h1.5v0.5h-1.5zM-0.5,-5.5h3.5v0.5h-3.5zM-1.5,-5h5v1h-5zM-4.5,-4.5h0.5v1h-0.5zM-3,-4.5h0.5v0.5h-0.5zM-3.5,-4h1v1h-1zM-2,-4h1v1h-1zM2,-4h2v1.5h-2zM-5,-3.5h0.5v1h-0.5zM-4,-3h3v0.5h-3zM-5,-2.5h3.5v0.5h-3.5zM2.5,-2.5h1.5v0.5h-1.5zM-5,-2h2.5v0.5h-2.5zM-2,-2h0.5v0.5h-0.5zM2.5,-2h0.5v0.5h-0.5zM3.5,-2h0.5v1h-0.5zM-5,-1.5h1v0.5h-1zM-3.5,-1.5h1v0.5h-1zM-5,-1h0.5v0.5h-0.5zM-3.5,-1h0.5v0.5h-0.5zM4,-1h0.5v0.5h-0.5z',
    },
    {
      paint: 'bushDark',
      d: 'M3,-5.5h1v0.5h-1zM3.5,-5h0.5v0.5h-0.5zM3.5,-4.5h1v0.5h-1zM4,-4h0.5v0.5h-0.5zM4,-3.5h1v2.5h-1zM4.5,-1h0.5v0.5h-0.5z',
    },
    {
      paint: 'leafLight',
      d: 'M-1,-7h0.5v0.5h-0.5zM-2.5,-6.5h3.5v1h-3.5zM-2.5,-5.5h2v0.5h-2zM-4,-5h2.5v0.5h-2.5zM-4,-4.5h1v0.5h-1zM-2.5,-4.5h1v0.5h-1zM-4,-4h0.5v0.5h-0.5zM-2.5,-4h0.5v1h-0.5zM-4.5,-3.5h1v0.5h-1zM-4.5,-3h0.5v0.5h-0.5z',
    },
  ],
  pixels: 186,
};
const variant2: PixelSprite = {
  layers: [
    { paint: 'shadow', d: 'M-1.5,0h0.5v0.5h-0.5zM-0.5,0h1v0.5h-1zM1,0h1v0.5h-1z' },
    {
      paint: 'trunk',
      d: 'M0,-5h1v0.5h-1zM0.5,-4.5h0.5v0.5h-0.5zM0,-4h1v0.5h-1zM0,-3.5h0.5v2h-0.5zM0,-1.5h1v1.5h-1zM-1,-0.5h0.5v1h-0.5zM0.5,0h0.5v0.5h-0.5z',
    },
    {
      paint: 'stump',
      d: 'M0,-4.5h0.5v0.5h-0.5zM-0.5,-4h0.5v0.5h-0.5zM-1,-3.5h1v1.5h-1zM-0.5,-2h0.5v2h-0.5z',
    },
    {
      paint: 'willow',
      d: 'M0.5,-8.5h1v0.5h-1zM-1.5,-8h0.5v0.5h-0.5zM1.5,-8h1v0.5h-1zM-2,-7.5h0.5v1.5h-0.5zM2,-7.5h1v0.5h-1zM1.5,-7h1.5v0.5h-1.5zM0,-6.5h3.5v0.5h-3.5zM-2.5,-6h0.5v0.5h-0.5zM-1,-6h4.5v1h-4.5zM-3,-5.5h0.5v0.5h-0.5zM-3.5,-5h0.5v1.5h-0.5zM-1.5,-5h0.5v1h-0.5zM1,-5h2.5v1h-2.5zM-2,-4h0.5v0.5h-0.5zM1,-4h0.5v0.5h-0.5zM2,-4h1.5v1.5h-1.5zM-3,-3.5h1.5v0.5h-1.5zM-4,-3h2.5v0.5h-2.5zM-4,-2.5h1.5v0.5h-1.5zM-2,-2.5h0.5v0.5h-0.5zM2.5,-2.5h0.5v1.5h-0.5zM-4,-2h1v0.5h-1zM-3.5,-1.5h0.5v0.5h-0.5z',
    },
    {
      paint: 'bushDark',
      d: 'M3.5,-6h0.5v1.5h-0.5zM3.5,-4.5h1v2h-1zM3,-2.5h1.5v0.5h-1.5zM3,-2h1v0.5h-1zM3.5,-1.5h0.5v1h-0.5z',
    },
    {
      paint: 'leafLight',
      d: 'M-1,-8h2.5v0.5h-2.5zM-1.5,-7.5h3.5v0.5h-3.5zM-1.5,-7h3v0.5h-3zM-1.5,-6.5h1.5v0.5h-1.5zM-2,-6h1v0.5h-1zM-2.5,-5.5h1.5v0.5h-1.5zM-3,-5h1.5v1h-1.5zM-3,-4h1v0.5h-1zM-3.5,-3.5h0.5v0.5h-0.5z',
    },
  ],
  pixels: 172,
};
export const sprites: readonly PixelSprite[] = [variant0, variant1, variant2];
